import { Translation } from "i18n/config";
import { PricingTranslations } from "./typing";
import { ProductKeys } from "containers/Pricing/products";

export const PricingTexts: Translation<PricingTranslations> = {
	es: {
		acquiredTalents: "Talentos adquiridos",
		acquiredChallenges: "Reto/s adquirido/s",
		alreadySubscribed: "Ya subscrito",
		refresh: "Recargar",
		createNewBusinessProfile: "Crear un nuevo Perfil Jurídico",
		listOfBusinessProfiles: "Listado de Perfiles Jurídicos",
		getTranslationByProductKey: (key: ProductKeys) => {
			switch (key) {
				case ProductKeys.Talents:
					return "Talentos";
				case ProductKeys.Elearnings:
					return "Elearnings";
				case ProductKeys.Challenges:
					return "Retos";
				default:
					return "";
			}
		},
		pricing: "Precio",
	},
	en: {
		acquiredTalents: "Acquired Talents",
		acquiredChallenges: "Acquired Challenge/s",
		alreadySubscribed: "Already subscribed",
		refresh: "Refresh",
		createNewBusinessProfile: "Create new Business Profile",
		listOfBusinessProfiles: "List of Business Profiles",
		getTranslationByProductKey: (key: ProductKeys) => {
			switch (key) {
				case ProductKeys.Talents:
					return "Talents";
				case ProductKeys.Elearnings:
					return "Elearnings";
				case ProductKeys.Challenges:
					return "Challenges";
				default:
					return "";
			}
		},
		pricing: "Pricing",
	},
	ca: {
		acquiredTalents: "Talentos adquiridos",
		acquiredChallenges: "Reto/s adquirido/s",
		alreadySubscribed: "Ya subscrito",
		refresh: "Refrescar",
		createNewBusinessProfile: "Crear un nuevo Perfil Jurídico",
		listOfBusinessProfiles: "Listado de Perfiles Jurídicos",
		getTranslationByProductKey: (key: ProductKeys) => {
			switch (key) {
				case ProductKeys.Talents:
					return "Talentos";
				case ProductKeys.Elearnings:
					return "Elearnings";
				case ProductKeys.Challenges:
					return "Retos";
				default:
					return "";
			}
		},
		pricing: "Precio",
	},
	pt: {
		acquiredTalents: "Talentos adquiridos",
		acquiredChallenges: "Desafio/s adquirido/s",
		alreadySubscribed: "Já inscrevi",
		refresh: "Recarrega",
		createNewBusinessProfile: "Criar um novo perfil jurídico",
		listOfBusinessProfiles: "Lista de Perfis Legais",
		getTranslationByProductKey: (key: ProductKeys) => {
			switch (key) {
				case ProductKeys.Talents:
					return "Talentos";
				case ProductKeys.Elearnings:
					return "Elearnings";
				case ProductKeys.Challenges:
					return "Desafios";
				default:
					return "";
			}
		},
		pricing: "Preço",
	},
};
